/* eslint-disable @typescript-eslint/no-deprecated -- DEPRECATION: [APPDEV-17834] BREAKING-CHANGE: migrate to ChartTooltip before next major. */
import { useEffect, useState } from 'react';

import Spacings from '@dynatrace/strato-design-tokens/spacings';

import { GanttChartTooltipBody } from './GanttChartTooltipBody.js';
import { GanttChartTooltipHeader } from './GanttChartTooltipHeader.js';
import { Divider } from '../../../../layouts/divider/Divider.js';
import { ChartTooltip } from '../../../core/components/tooltip/ChartTooltip/ChartTooltip.js';
import type { GanttChartContent } from '../../context/GanttChartStateContext.js';
import { useGanttSegmentsContext } from '../../context/GanttSegmentsContext.js';
import {
  useTooltipContent,
  useTooltipPinnedStatus,
} from '../../hooks/use-set-tooltip-state.js';

export const GanttChartTooltipContent = () => {
  const [tooltipContent, setTooltipContent] = useState<
    GanttChartContent | undefined
  >();

  const isTooltipPinned = useTooltipPinnedStatus();
  const storedTooltipContent = useTooltipContent();
  const {
    config: { xAxisType, tooltip, formatter },
  } = useGanttSegmentsContext();
  const isDate = xAxisType === 'time';

  useEffect(() => {
    if (!isTooltipPinned && storedTooltipContent) {
      setTooltipContent(storedTooltipContent);
    }
  }, [storedTooltipContent, isTooltipPinned]);

  if (!tooltipContent) {
    return null;
  }

  const { row, segment, parent } = tooltipContent;

  if (tooltip !== undefined) {
    return tooltip(segment, row, parent);
  }

  return (
    <>
      <GanttChartTooltipHeader
        segment={tooltipContent.segment}
        isDate={isDate}
        formatter={formatter}
      />
      <Divider
        orientation="horizontal"
        style={{ margin: `${Spacings.Size4} 0` }}
      />
      <ChartTooltip.Body>
        <GanttChartTooltipBody
          entry={tooltipContent.segment}
          row={row}
          parent={parent}
          isDate={isDate}
        />
      </ChartTooltip.Body>
    </>
  );
};

GanttChartTooltipContent['displayName'] = 'GanttChartTooltipBody';
